import './App.css';
import arrow from './assets/arrow.png';
import light from './assets/light.png';
import React, { useState, useEffect } from 'react';
import { Flex, Layout, Table, List, Col, Row } from 'antd';
import HeaderComponent from './components/Header';
import FooterComponent from './components/Footer';
import SearchComponent from './components/Search';
import unit from './unit';
import { useNavigate, Link } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import { color } from 'echarts';
const { Content } = Layout;

const App = () => {
    // 使用 useState 管理状态
    const [updtime, setUpdtime] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [stockDataSource, setStockDataSource] = useState([]);
    const [hotSource, setHotSource] = useState([]);
    const [niusanSource, setNiusanSource] = useState([]);
    const [gudongChangeList, setGudongChangeList] = useState([]);
    const [lastClickedStockCode, setLastClickedStockCode] = useState(null);

    const columns = [
        {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 50,
            className: 'center-align',
        },
        {
            title: '股东名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
            render: (text, record) => (
                <a href={`/detail/${record.code}`} target="_blank" onClick={() => setLastClickedStockCode(record.index)} style={{ color: '#333333', textDecoration: lastClickedStockCode === record.index ? 'underline' : 'none' }}>
                    {text}
                </a>
            ),
        },
        {
            title: '股票名称',
            dataIndex:'stock_name',
            key:'stock_name',
            className: 'center-align',
            width: 100,
            ellipsis: true,
            render: (text, record) => (
                <a href={`/particulars/${record.stock_code}`} target="_blank" onClick={() => setLastClickedStockCode(record.index)} style={{ color: '#333333', textDecoration: lastClickedStockCode === record.index ? 'underline' : 'none' }}>
                    {text}
                </a>
            ),
        },
        {
            title: '环比增减',
            dataIndex: 'change_desc',
            key: 'change_desc',
            width: 100,
            className: 'center-align',
            render: (text, record) => {
                let color = 'black'; // 默认颜色
                let content = text; // 默认内容
                if (text === '新进') {
                    color = 'orange';
                } else if (text === '未变') {
                    color = 'black';
                } else if (!isNaN(text)) { // 如果是数字
                    if (text > 0) {
                        color = 'red';
                        content = `+${text}%`;
                    } else if (text < 0) {
                        color = 'green';
                        content = `${text}%`;
                    }
                }
                return <span style={{ color }}>{content}</span>;
            },
        },
        {
            title: '股东类型',
            dataIndex: 'type',
            key: 'type',
            width: 100,
            className: 'center-align',
        },
    ];

    const stockColumns = [
        {
            title: '股票名称',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <a href={`/particulars/${record.code}`} target="_blank" onClick={() => setLastClickedStockCode(record.code)} style={{ color: '#333333', textDecoration: lastClickedStockCode === record.code ? 'underline' : 'none' }}>
                    {text}
                </a>
            ),
        },
        {
            title: '更新日期',
            dataIndex: 'date',
            key: 'date',
            className: 'center-align',
        },
    ];

    const navigate = useNavigate();

    // 模拟 componentWillMount，在组件挂载时执行搜索
    useEffect(() => {
        getLastGudongList();
        hotGudongList();
        getNiusanList();
        getGudongChangeList();
        getStockDataList();
    }, []);

    // 最新股东列表
    const getLastGudongList = () => {
        const path = '/dxwapp/gegu/getLastGudongList';
        let newDataSource = [];
        unit.httpGet(path, {}, (data) => {
            for (let i = 0; i < data.list.length; i++) {
                let tmp = {};
                tmp['index'] = i + 1;
                tmp['name'] = data.list[i].name;
                tmp['change_desc'] = data.list[i].change_desc;
                tmp['stock_name'] = data.list[i].stock_name;
                tmp['type'] = data.list[i].type;
                tmp['code'] = data.list[i].code;
                tmp['stock_code'] = data.list[i].stock_code;
                newDataSource.push(tmp);
            }
            setUpdtime(data.updtime);
            setDataSource(newDataSource);
        });
    };

    // 热门股东列表
    const hotGudongList = () => {
        const path = '/pc/gudong/getHotSearch';
        let hotsearch = [];
        unit.httpGet(path, { "pageSize": "5", "apiversion": "8.9", "page": 1, "type": 0 }, (data) => {
            for (let i = 0; i < data.list.length; i++) {
                let tmp = {};
                tmp['name'] = data.list[i].name;
                tmp['code'] = data.list[i].code;
                hotsearch.push(tmp);
            }
            setHotSource(hotsearch);
        });
    };

    // 牛散推荐列表
    const getNiusanList = () => {
        const path = '/dxwapp/cangwei/index';
        let niusanSource = [];
        unit.httpGet(path, { "type": "2", "apiversion": "8.9", "page": "1", "pagecount": "1" }, (data) => {
            let niusanList = data.recommend_list.list;
            for (let i = 0; i < niusanList.length; i++) {
                let tmp = {};
                tmp['name'] = niusanList[i].text;
                tmp['code'] = niusanList[i].param.param.code;
                tmp['stock_num'] = niusanList[i].stock_num;
                niusanSource.push(tmp);
            }
            console.info(niusanSource);
            setNiusanSource(niusanSource);
        });
    };

    const getGudongChangeList = () => {
        const path = "/Pc/Gudong/getGudongChangeList";
        let gudongChangeList = [];
        unit.httpGet(path, { "day": "20250930", "page": "1", "pagesize": "5", "type": "1" }, (data) => {
            for (let i = 0; i < data.list.length; i++) {
                let tmp = {};
                tmp['title'] = data.title;
                tmp['name'] = data.list[i].stock_name;
                tmp['code'] = data.list[i].stock_code;
                tmp['change_percent'] = data.list[i].change_percent;
                gudongChangeList.push(tmp);
            }
            setGudongChangeList(gudongChangeList);
        });
    };

    // 最新股票列表
    const getStockDataList = () => {
        const path = "/Pc/Gudong/getStockList";
        let _stockDataSource = [];
        unit.httpGet(path, { "page": "1", "pagesize": "10", "type": "1" }, (data) => {
            for (let i = 0; i < data.length; i++) {
                let tmp = {};
                tmp['name'] = data[i].stock_name;
                tmp['code'] = data[i].stock_code;
                tmp['date'] = data[i].date;
                _stockDataSource.push(tmp);
            }
            setStockDataSource(_stockDataSource);
        });
    };

    // 排行榜数字样式
    const getTextClassName = (index) => {
        if (index == 0) {
            return 'first-num';
        }
        if (index == 1) {
            return 'second-num';
        }
        if (index == 2) {
            return 'third-num';
        }
        return 'normal-num';
    };

    return (
        <div className="App">
            <Layout>
                <HeaderComponent></HeaderComponent>
                <Content>
                    <div className='header'>
                        <div className='content'>
                            <div className='search-area'>
                                <SearchComponent isHeader={false}></SearchComponent>
                            </div>
                            <div style={{ display: 'block' }}>
                                <Flex wrap vertical={false} justify="center" className='block-container' gap="30px">
                                    <div className='content-block' style={{ background: "linear-gradient( 180deg, #FFEACE 0%, #FFFFFF 20%)" }}>
                                        <div className='block-title'>
                                            热搜榜
                                            <img src={light} alt="Light Icon" className='light-icon' />
                                            <Link to="/hotsearch" className="block-more"> 更多 <img src={arrow} alt="More" /></Link>
                                        </div>
                                        <List
                                            itemLayout="horizontal"
                                            locale={{ emptyText: "暂无数据" }}
                                            size="small"
                                            split={false}
                                            dataSource={hotSource}
                                            renderItem={(item, index) => (
                                                <Link to={`/detail/${item.code}`} target="_blank" rel="noopener noreferrer">
                                                    <List.Item>
                                                        <div>
                                                            <span className={getTextClassName(index)}>{index + 1}</span>
                                                            {item.name}
                                                        </div>
                                                    </List.Item>
                                                </Link>
                                            )}
                                        />
                                    </div>
                                    <div className='content-block' style={{ background: "linear-gradient( 180deg, #FFDBDB 0%, #FFFFFF 20%)" }}>
                                        <div className='block-title'>
                                            牛散推荐
                                            <img src={light} alt="Light Icon" className='light-icon' />
                                            <Link to="/niusan" className="block-more"> 更多 <img src={arrow} alt="More" /></Link>
                                        </div>
                                        <List
                                            itemLayout="horizontal"
                                            locale={{ emptyText: "暂无数据" }}
                                            size="small"
                                            split={false}
                                            dataSource={niusanSource}
                                            renderItem={(item, index) => (
                                                <Link to={`/detail/${item.code}`} target="_blank" rel="noopener noreferrer">
                                                    <List.Item>
                                                        <div style={{ width: "100%" }}>
                                                            <span className={getTextClassName(index)}>{index + 1}</span>
                                                            {item.name} 
                                                            <span className="stock_tips">
                                                            持股 <span className="stock_num">{item.stock_num}</span>
                                                            </span>
                                                        </div>
                                                    </List.Item>
                                                </Link>
                                            )}
                                        />
                                    </div>
                                    <div className='content-block' style={{ background: "linear-gradient( 180deg, #D6E3FF 0%, #FFFFFF 20%)" }}>
                                        <div className='block-title'>
                                            股东增减仓
                                            {gudongChangeList.length > 0 && (
                                                <span className="block-title-sub">{gudongChangeList[0].title}</span>
                                            )}
                                            <img src={light} alt="Light Icon" className='light-icon' />
                                            <Link to="/increase" className="block-more"> 更多 <img src={arrow} alt="More" /></Link>
                                        </div>
                                        <List
                                            itemLayout="horizontal"
                                            locale={{ emptyText: "暂无数据" }}
                                            size="small"
                                            split={false}
                                            dataSource={gudongChangeList}
                                            renderItem={(item, index) => (
                                                <Link to={`/particulars/${item.code}`} target="_blank" rel="noopener noreferrer">
                                                    <List.Item>
                                                        <div style={{ width: "100%" }}>
                                                            <span className={getTextClassName(index)}>{index + 1}</span>
                                                            {item.name}
                                                            <span className='stock_tips'>持仓变动 <span className='change_percent' style={{ color: item.change_percent > 0 ? 'red' : 'green' }}>{item.change_percent}%</span></span>
                                                        </div>
                                                    </List.Item>
                                                </Link>
                                            )}
                                        />
                                    </div>
                                </Flex>
                            </div>
                            <div style={{ height: '39px' }}></div>
                        </div>
                    </div>
                    <div className='body'>
                        <Row>
                            <Col span={17} style={{ background: '#FFFFFF', margin: '0 20px 0 15px' }}>
                                <div className='row'>
                                    <div className='left title'>最近新入股东</div>
                                    <div className='right update_time'>最新数据更新于{updtime}</div>
                                    <div className='clear'></div>
                                </div>
                                <div className='table'>
                                    <Table 
                                        size='small' 
                                        columns={columns} 
                                        locale={{ emptyText: "暂无数据" }} 
                                        dataSource={dataSource} 
                                        rowClassName="custom-row" 
                                        pagination={false} 
                                    />
                                </div>
                            </Col>
                            <Col span={6} style={{ background: '#FFFFFF' }}>
                                <div className='row'>
                                    <div className='left title'>最近股票仓位</div>
                                    <div className='clear'></div>
                                </div>
                                <div className='table'>
                                    <Table 
                                        size='small' 
                                        columns={stockColumns} 
                                        locale={{ emptyText: "暂无数据" }} 
                                        dataSource={stockDataSource} 
                                        rowClassName="custom-row" 
                                        pagination={false} 
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Content>
                <FooterComponent></FooterComponent>
            </Layout>
        </div>
    );
};

export default App;